import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { Modal } from 'bricks-ui/packages/bricks-ui';

import { ModalWrapper } from './Modal.style';

const ModalRenderer = ({ children, ...props }) => (
  createPortal(
    <ModalWrapper>
      <Modal {...props}>
        {children}
      </Modal>
    </ModalWrapper>,
    document.body
  )
);

ModalRenderer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired
};

export default ModalRenderer;
